import { Component } from '@angular/core';
import { NavController, NavParams ,ToastController , ModalController} from 'ionic-angular';
import { Api } from "../../providers/api";
import { FormBuilder } from '@angular/forms';
import { Headers , RequestOptions } from '@angular/http';
import { SearchCustomersPage } from "../search-customers/search-customers";
import {SelectionSearchPage} from '../selection-search/selection-search';
import { SelectionSearchService } from '../../services/selection-search' ;
import  {LoginPage} from '../login/login';
import { MsgManager } from '../../providers/msg-manager';
import {GVLogger} from "../../services/gv-logger";


@Component({
  selector: 'page-edit-customer',
  templateUrl: 'edit-customer.html'
})
export class EditCustomerPage {


  userNameError = "";
  formStatus = false;

  countriesList: any;

  stateList1: any;
  cityList1: any;

  stateList2: any;
  cityList2: any;

  address1Country:any;
  address1State:any;
  address1City:any;

  address2Country:any;
  address2State:any;
  address2City:any;

  taxGroupList:any;
  customerGroupList:any;
  paymentTermsList:any;


  taxGroup:string;
  customerGroup:string;


  states1SelectControl:boolean = false;
  cities1SelectControl:boolean = false;

  states2SelectControl:boolean = false;
  cities2SelectControl:boolean = false;

  countryCodes = [];
  mask
  provinces = []
  provinces2 = []

	public form:any ;
	public customerMinimized : any;
	public customer: any = {
		id:0,
		customerId:"",
		name: "",
		contactPerson: "",
    userName:"",
    password:"",
		company:"",
		paymentCurrency:"",
		locationsDTOs: [{
			addressLine1:"",
			addressLine2:"",
			city:"",
			state:"",
			zipCode:"",
			country:"",
			receiverName:""
		},
		{
			addressLine1:"",
			addressLine2:"",
			city:"",
			state:"",
			zipCode:"",
			country:"",
			receiverName:""
		}]
	};
  getProvincesStatus = true
  getProvinces2Status = true
  currenciesList:any;
  constructor(public navCtrl: NavController,
  public navParams: NavParams,
  public api:Api ,
  public formBuilder:FormBuilder,
  public toastController:ToastController,
  public modalController:ModalController,
  public ss:SelectionSearchService,
  private msgManager:MsgManager,
  private gVLogger: GVLogger) {

    this.loadTaxGroups();
    this.loadCustomerGroups();
    this.loadPaymentTerms();
    // this.getCountryCodesList();

    this.getCountries();
    this.getCurrenciesList();




  	this.form ={
  		company:"",
  		paymentCurrency:"",
  		name:"",
      contactPerson:"",
  		email:"",
      userName:"",
      password:"",
  		phone:"",
      taxGropup:"",
      customerGroup:"",
  		isPrimary:false,
  		adress1name:"",
  		address1street: "",
  		address1city:"",
  		address1state:"",
  		adddress1zip:"",
  		address1country:"",
  		isSameAsAbove: false,
  		adress2name:"",
  		address2street: "",
  		address2city:"",
  		address2state:"",
  		adddres21zip:"",
  		address2country:""
  	}
  	this.customerMinimized  = this.navParams.get("customerMinimized");
  	this.getCustomerById(this.customerMinimized.id);

    // this.getProvincesWhileEditing(this.form.address1country)
    // this.getProvincesWhileEditing2(this.form.address2country)


   // this.getLookupCountries();

  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad EditCustomerPage');

  }


  getCustomerById(id){

    this.gVLogger.log("UUUUUUUUUUUUUUUUUUUUUUUUUu");

  	this.api.get("customers/"+id).map(res => res.json()).subscribe(result=>{
  		this.gVLogger.log(JSON.stringify(result.data));
  		if(result.status == "200"){

        let bool:Array<boolean> = [false,true];

  			this.customer = result.data;

  			this.form.company = this.customer.company;
  			this.form.paymentCurrency = this.customer.paymentCurrency;
  			this.form.name = this.customer.name;
  			this.form.contactPerson = this.customer.contactPerson;
  			this.form.email = this.customer.email;
        this.form.userName = this.customer.userName;
        this.form.password = this.customer.password;
  			this.form.phone = this.customer.phone;
        this.form.taxGroup = this.customer.taxGroup;
        this.form.customerGroup = this.customer.customerGroup;



        this.gVLogger.log(this.form.taxGroup);
        this.gVLogger.log(this.form.customerGroup);


  			if(this.customer.locationsDTOs.length > 0){
          this.gVLogger.log("EEEEEEEEEEEs " + this.customer.locationsDTOs.length);
  			  for(let loc of this.customer.locationsDTOs){


  			    if(loc.isShipToAddress === 1){
              this.gVLogger.log("lllllllllllll " + JSON.stringify(loc));
              this.form.address1name = loc.receiverName;
              this.form.shipToEmail = loc.email;
              this.form.shipToPhone = loc.phone;
              this.form.address1city = loc.city;
              this.form.address1street = loc.addressLine1 ;
              this.form.address1state = loc.state;
              this.form.address1zip = loc.zipCode;
              this.form.address1country = loc.country;
              // this.loadProvincesByCountryCode1(this.form.address1country);
              // this.loadCitiesByProvinceCode1(this.form.address1state);
              this.states1SelectControl = true;
              this.cities1SelectControl = true;

              if(loc.locationType === "BILLTOSHIPTO"){
                this.form.isSameAsAbove = true;
                // this.form.address1name = loc.receiverName;
                // this.form.address1city = loc.city;
                // this.form.address1street = loc.addressLine1;
                // this.form.address1state = loc.state;
                // this.form.address1zip = loc.zipCode;
                // this.form.address1country = loc.country;
                // this.form.isPrimary = bool[loc.isShipToAddress];
                // this.states1SelectControl = true;
                // this.cities1SelectControl = true;
              }
            }


  			    if(this.form.isSameAsAbove === false){
              if(this.customer.locationsDTOs.length > 0){
                for(let loc of this.customer.locationsDTOs){
                  if(loc.locationType === "BILLTO"){
                      this.form.address2name = loc.receiverName;
                      this.form.billToEmail = loc.email;
                      this.form.billToPhone = loc.phone;
                      this.form.address2city = loc.city;
                      this.form.address2street = loc.addressLine1;
                      this.form.address2state = loc.state;
                      this.form.address2zip = loc.zipCode;
                      this.form.address2country = loc.country;
                      // this.loadCitiesByProvinceCode2(this.form.address2state);
                      // this.loadProvincesByCountryCode2(this.form.address2country);
                      this.states2SelectControl = true;
                      this.cities2SelectControl = true;
                    break;
                  }
                }
              }
            }


            // if(this.customer.locationsDTOs[0].locationType == "BILLTOSHIPTO"){
            //   this.form.isSameAsAbove = true;
            //   this.form.address1name = this.customer.locationsDTOs[0].receiverName;
            //   this.form.address1city = this.customer.locationsDTOs[0].city;
            //   this.form.address1street = this.customer.locationsDTOs[0].addressLine1;
            //   this.form.address1state = this.customer.locationsDTOs[0].state;
            //   this.form.address1zip = this.customer.locationsDTOs[0].zipCode;
            //   this.form.address1country = this.customer.locationsDTOs[0].country;
            //   this.form.isPrimary = bool[this.customer.locationsDTOs[0].isShipToAddress];
            //   this.states1SelectControl = true;
            //   this.cities1SelectControl = true;
            // }else if( this.customer.locationsDTOs[1] != null){
            //   this.form.address2name = this.customer.locationsDTOs[1].receiverName;
            //   this.form.address2city = this.customer.locationsDTOs[1].city;
            //   this.form.address2street = this.customer.locationsDTOs[1].addressLine1;
            //   this.form.address2state = this.customer.locationsDTOs[1].state;
            //   this.form.address2zip = this.customer.locationsDTOs[1].zipCode;
            //   this.form.address2country = this.customer.locationsDTOs[1].country;
            //   this.loadCitiesByProvinceCode2(this.form.address2state);
            //   this.loadProvincesByCountryCode2(this.form.address2country);
            //   this.states2SelectControl = true;
            //   this.cities2SelectControl = true;
            // }
          }




  			}

        console.log("STATEEEEE " + this.form.address1state)

        this.getProvincesWhileEditing(this.form.address1country)
        this.getProvincesWhileEditing2(this.form.address2country)

  			}else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }




  			this.gVLogger.log(JSON.stringify(this.form));
  	});
  }

  sameShipToAddressChanged(event){
    this.gVLogger.log("EEEEEEEEEEEEEEE " + event);
  }



  updateCustomer(){

    this.validateForm();

    if(this.formValidation()){




          var locations = [];

          let id = 0;
          let locationsType = "";

      if(this.customer.locationsDTOs.length > 0) {

        for (let loc of this.customer.locationsDTOs) {
          if(loc.isShipToAddress === 1){
            id = loc.id;
            locationsType = loc.locationType;
          }

        }
      }

      let locationShipto = {
        id: id,
        receiverName: this.form.address1name,
        email: this.form.shipToEmail,
        phone: this.form.shipToPhone,
        addressLine1: this.form.address1street,
        addressLine2: "",
        city: this.form.address1city,
        state: this.form.address1state,
        zipCode: this.form.address1zip,
        country: this.form.address1country,
        isShipToAddress: 1,
        locationType: "SHIPTO"
      }

      if(this.form.isSameAsAbove === true && locationsType === "BILLTOSHIPTO"){
        locationShipto.locationType = "BILLTOSHIPTO";
        locations.push(locationShipto);
      }else if(this.form.isSameAsAbove === true && locationsType === "SHIPTO"){
        locationShipto.locationType = "BILLTOSHIPTO";
        locations.push(locationShipto);
      }else if(this.form.isSameAsAbove === false && locationsType === "BILLTOSHIPTO"){
        locationShipto.locationType = "SHIPTO";
        locations.push(locationShipto);
        let locationBillto = {
          id: 0,
          receiverName: this.form.address2name,
          email: this.form.billToEmail,
          phone: this.form.billToPhone,
          addressLine1: this.form.address2street,
          addressLine2: "",
          city: this.form.address2city,
          state: this.form.address2state,
          zipCode: this.form.address2zip,
          country: this.form.address2country,
          isShipToAddress: 0,
          locationType: "BILLTO"
        }
        locations.push(locationBillto);

      }else if(this.form.isSameAsAbove === false && locationsType === "SHIPTO"){
        locationShipto.locationType = "SHIPTO";
        locations.push(locationShipto);

        let id = 0;
        if(this.customer.locationsDTOs.length > 0){
          for(let loc of this.customer.locationsDTOs){
            if(loc.locationType === "BILLTO"){
              id = loc.id;
              break;
            }
          }
        }

        let locationBillto = {
          id: id,
          receiverName: this.form.address2name,
          addressLine1: this.form.address2street,
          addressLine2: "",
          city: this.form.address2city,
          state: this.form.address2state,
          zipCode: this.form.address2zip,
          country: this.form.address2country,
          isShipToAddress: 0,
          locationType: "BILLTO"
        }
        locations.push(locationBillto);
      }

    // if(this.form.isSameAsAbove) {
    //   locationShipto.locationType = "BILLTOSHIPTO";
    //   locations.push(locationShipto);
    // }else{
    //   let locationBillto = {
    //     receiverName: this.form.address2name,
    //   addressLine1: this.form.address2street,
    //     addressLine2: "",
    //     city: this.form.address2city,
    //     state: this.form.address2state,
    //     zipCode: this.form.address2zip,
    //     country: this.form.address2country,
    //     isShipToAddress: 0,
    //     locationType: "BILLTO"
    // }
    //
    //   locations.push(locationShipto);
    //   locations.push(locationBillto);
    // }

    var postJSON = {
     id:this.customer.id,
     company:this.form.company,
     paymentCurrency:this.form.paymentCurrency,
     name: this.form.name,
     contactPerson: this.form.contactPerson,
     phone: this.form.phone,
     taxGroup: this.form.taxGroup,
     customerGroup: this.form.customerGroup,
     email: this.form.email,
     salesPersonCode: this.customer.salesPersonCode,
     shippingServiceDTOsc:this.customer.shippingServiceDTOs,
     // userName: this.form.userName,
     // password: this.form.password,
     locationsDTOs: locations
    }

    this.gVLogger.log(JSON.stringify(this.form));

  let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });

    this.formStatus = false;
    this.api.post("customers/add",JSON.stringify(postJSON),options)
    .map(res => res.json())
      .subscribe(data => {
    if(data.status == "200"){
      this.msgManager.toastMsg("Customer Updated Successful");
      this.navCtrl.setRoot(SearchCustomersPage);
    }else if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }




      });

  this.gVLogger.log(JSON.stringify(postJSON));





    }else{

      // this.presentToast("Please fill all the required fields","bottom");
    }


  }



  loadProvincesByCountryCode1(countryCode1){
    this.api.get("lookup/codesByCode?codeString="+countryCode1).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.navCtrl.setRoot(LoginPage);
      }
      if(result.status == "200"){
        this.gVLogger.log("loadbycode"+result);
        this.stateList1 = result.data;
      }
    });
  }

  loadCitiesByProvinceCode1(provinceCode1){
  this.api.get("lookup/codesByCode?codeString="+provinceCode1).map(res => res.json()).subscribe(result=>{
        this.gVLogger.log(result);
        if(result.status == "200"){
          this.gVLogger.log("loadbycode"+result);
          this.cityList1 = result.data;
        }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
      });
  }

  loadProvincesByCountryCode2(countryCode2){
    this.api.get("lookup/codesByCode?codeString="+countryCode2).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.gVLogger.log("loadbycode"+result);
        this.stateList2 = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }

  loadCitiesByProvinceCode2(provinceCode2){
  this.api.get("lookup/codesByCode?codeString="+provinceCode2).map(res => res.json()).subscribe(result=>{
        this.gVLogger.log(result);
        if(result.status == "200"){
          this.gVLogger.log("loadbycode"+result);
          this.cityList2 = result.data;
        }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
      });
  }





  getLookupCountries(){

    this.api.get("lookup/codesByTable?tableName=country").map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.countriesList = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });

  }


  country1Changed(){

    // this.gVLogger.log(this.form.address1country);
    // let countryId = this.form.address1country;
    // // for (let country of this.countriesList) {
    // //   // code...
    // //   if(country.code == this.form.address1country){
    // //     countryId = country.id;
    // //   }
    // // }
    //
    // this.api.get("lookup/codesByCode?codeString=" + countryId).map(res => res.json()).subscribe(result=>{
    //   this.gVLogger.log(result);
    //   if(result.status == "200"){
    //     this.stateList1 = result.data;
    //     this.form.address1state = "";
    //     this.form.address1city = "";
    //
    //      this.states1SelectControl = true;
    //      this.cities1SelectControl = false;
    //   }
    // });


  }

  country2Changed(){

    // let countryId= this.form.address2country;
    // // for (let country of this.countriesList) {
    // //   // code...
    // //   if(country.country == this.form.address2country){
    // //     countryId = country.id;
    // //   }
    // // }
    //
    // this.api.get("lookup/codesByCode?codeString=" + countryId).map(res => res.json()).subscribe(result=>{
    //   this.gVLogger.log(result);
    //   if(result.status == "200"){
    //     this.stateList2 = result.data;
    //     this.form.address2state = "";
    //     this.form.address2city = "";
    //     this.states2SelectControl = true;
    //     this.cities2SelectControl = false;
    //   }else if(result.status == "401"){ // check for session out
    //       this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
    //       this.navCtrl.setRoot(LoginPage);
    //     }
    // });


  }

  state1Changed(){

    let provinceId = this.form.address1state;
    // for (let province of this.stateList1) {
    //   // code...
    //   if(province.province == this.form.address1state){
    //     provinceId = province.id;
    //   }
    // }

    this.api.get("lookup/codesByCode?codeString=" + provinceId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.cityList1 = result.data;
        this.form.address1city = "";
        this.cities1SelectControl = true;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });


  }

  state2Changed(){

    let provinceId= this.form.address2state;
    // for (let province of this.stateList2) {
    //   // code...
    //   if(province.province == this.form.address2state){
    //     provinceId = province.id;
    //   }
    // }

    this.api.get("lookup/codesByCode?codeString=" + provinceId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.cityList2 = result.data;
        this.form.address2city = "";
        this.cities2SelectControl = true;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }


  loadTaxGroups(){
    this.api.get("lookup/taxGroups").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.taxGroupList = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }

  loadCustomerGroups(){
    this.api.get("lookup/customerGroups").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.customerGroupList = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }


  loadPaymentTerms(){
  // let body = new FormData();
  // body.append("tableName", "termsCode");

  this.api.get("lookup/codesByTable?tableName=termsCode").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.paymentTermsList = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }


  checkUsernameUniqeness(){

    this.gVLogger.log(this.form.userName +" -- value Check ");
   // var body:any = { "query":};

    let body = new FormData();
    body.append('query', this.form.userName );

    let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });

      this.gVLogger.log(JSON.stringify(body));
    this.api.post('customers/availability',body)
      .map(res => res.json())
        .subscribe(resp => {
          this.gVLogger.log(JSON.stringify(resp));
          if(resp.status=="200"){
            this.formStatus = true;
            this.userNameError = "";
            this.validateForm();
          }else if(resp.status=="500"){
            this.userNameError = "error";
            this.formStatus = false;
            this.msgManager.toastMsg("Username not available please choose other.");
          }else if(resp.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
        });
  }


 showModalCountry1(){

    this.ss.setItemsList(this.countriesList);
    this.gVLogger.log("countries : "+  this.ss.getItemsList());
    this.ss.setVariableType("country1");
    let modal = this.modalController.create(SelectionSearchPage);
    modal.onWillDismiss(data => {
     this.gVLogger.log("dismiss"+data);
     if(data != null){
       if(data.viewType == "country1"){
         this.form.address1country = data.item.code;
         //this.customerCreateForm.controls['address1country'].setValue(data.item.code);
         this.gVLogger.log("code"+data.item.code);
         //this.gVLogger.log("code form",this.customerCreateForm.controls.address1country._value);
        this.country1Changed();
       }
     }
   });
    modal.present();
  }


 // showModalState1(){
 //    if(this.states1SelectControl){
 //        this.ss.setItemsList(this.stateList1);
 //        this.gVLogger.log("countries : "+  this.ss.getItemsList());
 //        this.ss.setVariableType("state1");
 //        let modal = this.modalController.create(SelectionSearchPage);
 //        modal.onWillDismiss(data => {
 //         this.gVLogger.log("dismiss"+data);
 //         if(data != null){
 //           if(data.viewType == "state1"){
 //             this.form.address1state = data.item.code;
 //             this.gVLogger.log("code"+data.item.code);
 //
 //            this.state1Changed();
 //           }
 //         }
 //       });
 //        modal.present();
 //      }
 //    }

    showModalCiy1(){
    if(this.cities1SelectControl){
        this.ss.setItemsList(this.cityList1);
        this.gVLogger.log("countries : "+  this.ss.getItemsList());
        this.ss.setVariableType("city1");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
         this.gVLogger.log("dismiss"+data);
         if(data != null){
           if(data.viewType == "city1"){
             this.form.address1city = data.item.code;
             this.gVLogger.log("code"+data.item.code);
             this.validateForm();
           }
         }
       });
        modal.present();
      }
    }






    showModalCountry2(){

    this.ss.setItemsList(this.countriesList);
    this.gVLogger.log("countries : "+  this.ss.getItemsList());
    this.ss.setVariableType("country2");
    let modal = this.modalController.create(SelectionSearchPage);
    modal.onWillDismiss(data => {
     this.gVLogger.log("dismiss"+data);
     if(data != null){
       if(data.viewType == "country2"){
         this.form.address2country = data.item.code;
         this.gVLogger.log("code"+data.item.code);

        this.country2Changed();
       }
     }
   });
    modal.present();
  }


  showModalState2(){
    if(this.states2SelectControl){
        this.ss.setItemsList(this.stateList2);
        this.gVLogger.log("countries : "+  this.ss.getItemsList());
        this.ss.setVariableType("state2");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
         this.gVLogger.log("dismiss"+data);
         if(data != null){
           if(data.viewType == "state2"){
             this.form.address2state = data.item.code;
             this.gVLogger.log("code"+data.item.code);
            this.state2Changed();
           }
         }
       });
        modal.present();
      }
    }

    showModalCiy2(){
    if(this.cities2SelectControl){
        this.ss.setItemsList(this.cityList2);
        this.gVLogger.log("countries : "+  this.ss.getItemsList());
        this.ss.setVariableType("city2");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
         this.gVLogger.log("dismiss"+data);
         if(data != null){
           if(data.viewType == "city2"){
             this.form.address2city = data.item.code;
             this.gVLogger.log("code"+data.item.code);
             this.validateForm();
           }
         }
       });
        modal.present();
      }
    }



validateForm(){

      if(
        this.form.company != "" && // Company Name
        this.form.paymentCurrency != "" && // Company Name
        this.form.name != "" &&  // Name Prefix
        this.form.email != "" && // Email
        // this.form.userName != "" && // User Name
        // this.form.password != "" && // Password
        this.form.taxGroup != "" &&  // taxGroup
        this.form.customerGroup != "" &&  // Customer group
        this.form.address1city != "" // city 1  ////////////////
         ){

        // var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        // // Email validation
        // if (this.customerCreateForm.controls.email._value != "" &&
        //   (this.customerCreateForm.controls.email._value.length <= 5 ||
        //     !EMAIL_REGEXP.test(this.customerCreateForm.controls.email._value))) {
        //     //this.presentToast("Enter a Valid Email","middle");
        //     this.emailError = true;
        //     this.formStatus = false;
        // }else{
           // Form is verified
          this.formStatus = true;
       // }


        }else{
          this.formStatus = false;
        }

    }

    presentToast(msg,position) {
      let toast = this.toastController.create({
        message: msg,
        duration: 3000,
        position: position
      });
      toast.present();
    }

  getCountryCodesList(){
    this.api.getRA("/api/v1/codes/all/0").subscribe(result=>{
      this.countryCodes=result.json().data;
      console.log("CountryCodes from RA Service", this.countryCodes);
    });
  }

  getCountries(){
    this.api.getRA("/api/v1/codes/all/0").subscribe(result=>{
      this.countryCodes=result.json().data;
      console.log("CountryCodes from RA Service", this.countryCodes);
    },err=>{
      console.log("Error", err);
    });
  }

  getProvinces(event){
    if (!this.getProvincesStatus){
      // alert("fsfdfsdfsd" + JSON.stringify(event) + " gfgfgf " + this.form.address1country)

    this.form.address1state = ""
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+event)
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{

          this.provinces =  data.json().lookups

          // this.paymentProcessingCode = data.json().lookups;
        }
      },err=>{
        console.log("Error", err);
      });
    }
    this.getProvincesStatus = false
  }

  getProvinces2(event){
    if (!this.getProvinces2Status){

    this.form.address2state = ""
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+event)
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{

          this.provinces2 =  data.json().lookups

          // this.paymentProcessingCode = data.json().lookups;
        }
      },err=>{
        console.log("Error", err);
      });
    }
    this.getProvinces2Status = false;

  }

  getProvincesWhileEditing(abbreviation){

    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+abbreviation)
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{
          this.provinces =  data.json().lookups
        }
      },err=>{
        console.log("Error", err);
      });

  }

  getProvincesWhileEditing2(abbreviation){

    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+abbreviation)
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{
          this.provinces2 =  data.json().lookups
        }
      },err=>{
        console.log("Error", err);
      });

  }

  formValidation(){
    if(this.form.name === undefined || this.form.name === ""){
      this.api.toastMSG("Customer name can't be empty.")
      return false;
    }else if(this.form.contactPerson === undefined || this.form.contactPerson === ""){
      this.api.toastMSG("Customer contact person can't be empty.")
      return false;
    }else if(this.form.paymentCurrency === undefined || this.form.paymentCurrency === ""){
      this.api.toastMSG("Customer payment currency can't be empty.")
      return false;
    }else if(this.form.email === undefined || this.form.email === ""){
      this.api.toastMSG("Customer email can't be empty.")
      return false;
    }else if(this.form.phone === undefined || this.form.phone === ""){
      this.api.toastMSG("Customer phone can't be empty.")
      return false;
    }else if(this.form.address1name === undefined || this.form.address1name === ""){
      this.api.toastMSG("Bill to address contact name can't be empty.")
      return false;
    }
    else if(this.form.shipToEmail === undefined || this.form.shipToEmail === ""){
      this.api.toastMSG("Bill to address email can't be empty.")
      return false;
    }
    else if(this.form.shipToPhone === undefined || this.form.shipToPhone === ""){
      this.api.toastMSG("Bill to address phone can't be empty.")
      return false;
    }
    else if(this.form.address1country === undefined || this.form.address1country === ""){
      this.api.toastMSG("Bill to address country can't be empty.")
      return false;
    }else if(this.form.address1city === undefined || this.form.address1city === ""){
      this.api.toastMSG("Bill to address city can't be empty.")
      return false;
    }else if(this.form.address1state === undefined || this.form.address1state === ""){
      this.api.toastMSG("Bill to address state can't be empty.")
      return false;
    }else if(this.form.address1street === undefined || this.form.address1street === ""){
      this.api.toastMSG("Bill to address street can't be empty.")
      return false;
    }else if(this.form.address1zip === undefined || this.form.address1zip === ""){
      this.api.toastMSG("Bill to address postal code can't be empty.")
      return false;
    }else if(!this.form.isSameAsAbove && (this.form.address2name === undefined || this.form.address2name === "")){
      this.api.toastMSG("Ship to address contact name can't be empty.")
      return false;
    }
    else if(!this.form.isSameAsAbove && (this.form.billToEmail === undefined || this.form.billToEmail === "")){
      this.api.toastMSG("Ship to address email can't be empty.")
      return false;
    }

    else if(!this.form.isSameAsAbove && (this.form.billToPhone === undefined || this.form.billToPhone === "")){
      this.api.toastMSG("Ship to address phone can't be empty.")
      return false;
    }else if(!this.form.isSameAsAbove && (this.form.address2country === undefined || this.form.address2country === "")){
      this.api.toastMSG("Ship to address country can't be empty.")
      return false;
    }else if(!this.form.isSameAsAbove && (this.form.address2city === undefined || this.form.address2city === "")){
      this.api.toastMSG("Ship to address city can't be empty.")
      return false;
    }else if(!this.form.isSameAsAbove && (this.form.address2state === undefined || this.form.address2state === "")){
      this.api.toastMSG("Ship to address state can't be empty.")
      return false;
    }else if(!this.form.isSameAsAbove && (this.form.address2street === undefined || this.form.address2street === "")){
      this.api.toastMSG("Ship to address street can't be empty.")
      return false;
    }else if(!this.form.isSameAsAbove && (this.form.address2zip === undefined || this.form.address2zip === "")){
      this.api.toastMSG("Ship to address postal code can't be empty.")
      return false;
    }else {
      return true;
    }
  }

  getCurrenciesList(){
    // let body = new FormData();
    // body.append("tableName", "termsCode");

    this.api.geJazzba("/lookups/search/%20/0/100/currency").map(res => res.json()).subscribe(result =>{
      // if(result.status == "200"){
      this.currenciesList = result.lookups;
      // }else if(result.status == "401"){ // check for session out
      //   this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
      //   this.navCtrl.setRoot(LoginPage);
      // }
    });
  }


}









// WEBPACK FOOTER //
// ./src/pages/edit-customer/edit-customer.ts